import React from 'react';
import { ArrowRight } from 'lucide-react';

const CTABanner = ({ className }) => {
  return (
    <section className={`py-16 sm:py-20 px-4 bg-gradient-to-r from-[#4c4e13] to-[#0e1531] text-white text-center ${className}`}>
      <div className="container mx-auto">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 font-poppins leading-tight">
          Ready to Start Your Project?
        </h2>
        <p className="text-base sm:text-lg md:text-xl text-gray-200 mb-8 font-serif">
          Let's build something amazing together. Contact us to discuss your ideas and see how we can help you achieve your goals.
        </p>
        <a href="/contact" className="bg-[#364A9A] hover:bg-[#ECEE07] text-white hover:text-black font-bold py-3 px-6 sm:px-8 rounded-lg shadow-lg transition duration-300 ease-in-out transform hover:scale-105 inline-flex items-center justify-center">
          Get Started <ArrowRight size={20} className="ml-2" />
        </a>
      </div>
    </section>
  );
};

export default CTABanner;
